import { Api } from '@deepcloud/api-base'
import { mergeConfig } from '@deepcloud/http-client'
import type {
  HttpClient,
  HttpClientRequestConfig,
} from '@deepcloud/http-client'
import type {
  AdminListFeedbackParams,
  FeedbackDetail,
  FeedbackListResponse,
  FeedbackStatusUpdate,
} from '../../@types'

export class AdminAPI extends Api {
  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  /**
   * List Feedback
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async listFeedback(
    params?: AdminListFeedbackParams,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/admin/chat/feedback`

    return this.httpClient.get<FeedbackListResponse>(
      path,
      mergeConfig({ params }, config),
    )
  }

  /**
   * Get Feedback
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async getFeedback(feedbackId: number, config?: HttpClientRequestConfig) {
    const path = `/admin/chat/feedback/${feedbackId}`

    return this.httpClient.get<FeedbackDetail>(path, config)
  }

  /**
   * Update Feedback
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async updateFeedback(
    feedbackId: number,
    payload: FeedbackStatusUpdate,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/admin/chat/feedback/${feedbackId}`

    return this.httpClient.patch<FeedbackDetail>(path, payload, config)
  }
}
